module.exports = __webpack_public_path__ + "32944936a2f7f5df90898e326cfbe92a.png";